import { z } from 'zod'

export const StockTransferFormSchema = z.object({
  skuId: z.string().min(1),
  fromWarehouseId: z.string().min(1),
  toWarehouseId: z.string().min(1),
  quantity: z.coerce.number().int().positive({
    message: 'warehouse.stockTransfers.form.quantity.positive',
  }),
  batchNumber: z.string().nullable().optional(),
  note: z.string().nullable().optional(),
}).refine((data) => data.fromWarehouseId !== data.toWarehouseId, {
  message: 'warehouse.stockTransfers.form.warehouses.mustDiffer',
  path: ['toWarehouseId'],
})

export type StockTransferFormValues = z.infer<typeof StockTransferFormSchema>
